

export function dataTooltip(d) {
    return ["data-tooltip", d];
}

